import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { defaultRoute, findRoute } from '@/config/app';
import { useAuthStore } from '@/stores/authStore';

type AdminGuardProps = {
  children: ReactNode;
};

export default function AdminGuard({ children }: AdminGuardProps) {
  const access = useAuthStore((state) => state.currentUser?.access);

  if (access !== 'admin') {
    return (
      <Navigate replace to={findRoute('/exception/403')?.path ?? defaultRoute.path} />
    );
  }

  return children;
}
